
import axios from 'axios';
import utils from '@/utils/utils';
import {wxShare} from '@/utils/wechat-util';
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import {HeadBar, ImgCount, Card, PopupCalendar, DateBox, StarLevel, BccBannerBar, Evaluation} from '@/components';
import Apartment from './components/Apartment';
import HotelIntroduce from './components/HotelIntroduce';
import RoomFilterCondition from './components/RoomFilterCondition';
import PopFilterBox from './components/PopFilterBox';
import {OrderProxy, HotelProxy} from '@/http/RequestProxy.class';
import {mapGetters} from 'vuex';
import NearbyHotel from "./components/NearbyHotel";

const orderProxy = new OrderProxy();
const hotelProxy = new HotelProxy();
const wapUrl = process.env.WAP_URL;

let DefaultRoomTypeData = []; 

const planFilter = {
/** 是否含餐过滤 */
mealOfferFilter(planData, isOfferMeal, mealCount){
let tempData = planData;

if(isOfferMeal !== ''){
tempData = tempData.filter(item => {
return item.is_offer_meal === Boolean(+isOfferMeal);
});
}


if(+isOfferMeal === 1 && mealCount !== '' && mealCount !== undefined && mealCount !== null){
tempData = tempData.filter(item => {
return +item.meal_count === +mealCount;
});
}

return tempData;
},

/** 床型过滤 */
bedTypeFilter(planData, bedType){
let tempData = planData;

if(bedType === 'TWIN' || bedType === 'DOUBLE'){
tempData = planData.filter(item => {
return item.room_bed_category === bedType;
});
}else if(bedType === 'OTHER'){
tempData = planData.filter(item => {
return item.room_bed_category !== 'TWIN' && item.room_bed_category !== 'DOUBLE';
});
}

return tempData;
},

/** 免费取消过滤 */
freeCancelFilter(planData, canCancel){
if(+canCancel === 1){
planData = planData.filter(item => {
return item.is_able_to_cancel === 1;
});
}

return planData;
},
};

/**
* 房型数据过滤
* @param planData
* @param filtersObj
* @returns {Array}
*/
function doPlanFilter(planData, filtersObj) {
let targetData = planData;

for(let k in planFilter){
switch (k){
case 'mealOfferFilter':
targetData = planFilter[k](targetData, filtersObj.isOfferMeal, filtersObj.mealCount);
break;
case 'bedTypeFilter':
targetData = planFilter[k](targetData, filtersObj.bedType);
break;
case 'freeCancelFilter':
targetData = planFilter[k](targetData, filtersObj.isCanCancel);
break;
default: break;
}
}

return targetData;
}

/**
* 不同房型之间的排序(跨供应商拼接后整体排序)
* 规则(用户需求): "价格优先 > 手动优先级 > 供应商排序可手动配置"
*   1) 价格优先:    min_price 升序
*   2) 手动优先级:  htl_room_type.priority 升序(数字越小越靠前)
*   3) 供应商优先级: represent_platform_priority 升序
*                   (后端 HotelPlanRanker::setRepresentSupplier 已打标, 数字越小越靠前;
*                    具体数值由后端 config/supplier_priority.php 配置, 可手动调整顺序/新增供应商,
*                    无需改任何业务代码)
* 注: 房型内 plan_list 的"含餐分组取最低价+价格升序"已由后端统一处理, 前端不再做.
*
* @param roomList
* @returns {Array}
*/
function sortRoomListBySupplierPriority(roomList) {
const list = Array.isArray(roomList) ? roomList.slice() : [];

if (list.length <= 1) {
return list;
}

function priceOf(room) {
return +room.min_price || +room.lowest_price || Number.MAX_SAFE_INTEGER;
}

function priorityOf(room) {
return +room.priority || 9999;
}


function platformPriorityOf(room) {
return +room.represent_platform_priority || 9999;
}

return list.sort((a, b) => {

const priceDiff = priceOf(a) - priceOf(b);
if (priceDiff !== 0) {
return priceDiff;
}


const priorityDiff = priorityOf(a) - priorityOf(b);
if (priorityDiff !== 0) {
return priorityDiff;
}


return platformPriorityOf(a) - platformPriorityOf(b);
});
}

export default {
name: 'hotel-detail',
components: {
NearbyHotel,
BccBannerBar,
HotelIntroduce,
StarLevel,
Card,
ImgCount,
HeadBar,
Flexbox,
FlexboxItem,
Apartment,
DateBox,
PopupCalendar,
RoomFilterCondition,
PopFilterBox,
Evaluation,
},
data(){
return {
isShowAllPlanCondition: false,  // 显示所有房型方案筛选条件
isShowPopFilter: false,   // 显示餐食和房型过滤组件
isShowDefaultList: true,  // 显示酒店套餐占位图片
isShowCalendar: false,    // 显示日历
isShowRoomFilter: false,  // 显示房型筛选组件
currentScrollName: 'booking', // 当前滚动条位置名称
beginDateForArr: [],
endDateForArr: [],
isPullDown: false,
params: {},    // 请求字段
hotel: {
id: '',
},
hotelBaseInfo: {},      // 酒店基本详情数据
roomList: [],           // 房型列表
recommendRoomList: [],  // 推荐房型列表
mealCountOptions: [],   // 可选的含餐数量（筛选下拉用）

dynamicPlanCondition: {},  // 动态房型方案条件

evalList: [],   // 酒店评价数据
isCollected: 0, // 收藏状态
};
},
computed: {
...mapGetters(['getRooms', 'getAdults', 'getAges', 'getChildren']),


totalPerson(){
return this.getChildren + this.getAdults;
},

lanType(){
return +window.localStorage.getItem('lan_type');
},

/** 是否收藏了当前酒店 */



},




created(){
this.init();
},
mounted(){
utils.transformSVGA('#courseDetailSvga', '/m/static/animate-source/list-animate-bg.svga');
utils.transformSVGA('#baigolfLoading', '/m/static/animate-source/inline-loading.svga');

this.getHotelDetail();
this.beginDateForArr = this.params.start_date.split('-');
this.endDateForArr = this.params.end_date.split('-');
},







beforeDestroy(){
window.removeEventListener('scroll', this.scrollCallback);
},
methods: {
init(){

const query = this.$route.query;

utils.saveLangAndCurrency(query);
if(query.from_bg === 'yes'){
this.$store.dispatch('setRooms', 1);
this.$store.dispatch('setAdults', 1);
this.$store.dispatch('setChildren', 0);
}

this.params = this.$route.params;
this.mixParams();
this.getHotelEvals();
},

/** 获取酒店详情数据 */
getHotelDetail(){
hotelProxy.getHotelBaseInfo(this.params)
.then(resp => {
if(resp){
const data = resp.data;

if(Object.keys(this.hotelBaseInfo).length <= 0){
this.hotel.id = data.hotel_id;
this.hotelBaseInfo = data;

this.getRoomsData();
}

this.isCollected = data.is_collection;


wxShare({
title: `${data.hotel_name}${this.$i18n.t('WX_SHARED.DETAIL_TITLE')}`,
desc: data.hotel_introduce,
imgUrl: data.main_pic,
});
}
setTimeout(() => {
this.listenerScroll();
}, 300);
});
},

/** 收藏酒店 */
onCollect(){
const params = {
is_collection: +this.isCollected === 1 ? 0 : 1,
collection_id: this.hotel.id,
collection_type: 'HOTEL',
};

hotelProxy.collectionHotel(params)
.then(resp => {
if(resp){
const collect = +this.isCollected === 1 ? 0 : 1;

this.isCollected = collect;
if(this.isCollected === 1){
this.$vux.toast.show({
text: this.$i18n.t('hotel.COLLECTED_SUCCEED'),
});
}else{
this.$vux.toast.show({
text: this.$i18n.t('hotel.CANCEL_COLLECT'),
});
}
}
});
},

onShowAllRoomCondition(isFixed){
if(!isFixed){
this.onScroll2Booking('booking');
}
this.isShowAllPlanCondition = true;
},

/** 获取当前酒店的评价数据 */
getHotelEvals(){
hotelProxy.getHotelEvaluationList({hotel_id: this.params.hotel_id, page: 1})
.then(resp => {
if(resp){
this.evalList = resp.data.reviews.rows;
}
});
},

/** 筛选房型数据 */
onFilterRooms(filtersObj){
const originRoomData = JSON.stringify(DefaultRoomTypeData);
const result = [];

JSON.parse(originRoomData).forEach(item => {


item.plan_list = doPlanFilter(item.plan_list, filtersObj);
result.push(item);
});

this.roomList = sortRoomListBySupplierPriority(result);
this.isShowAllPlanCondition = false;
this.dynamicPlanCondition = filtersObj;
},

/** 整理可选的含餐数量（筛选下拉用），按后台返回数据的含餐数量去重升序 */
updateMealCountOptions(){
const options = new Set();

DefaultRoomTypeData.forEach(room => {
(room.plan_list || []).forEach(plan => {
if(+plan.meal_count > 0){
options.add(+plan.meal_count);
}
});
});

this.mealCountOptions = Array.from(options).sort((a, b) => a - b);
},

/** 获取房型数据 */
/* ---------------- 旧逻辑(前端循环逐个供应商请求)已废弃, 改为后端聚合接口, 代码保留仅供参考 ----------------
getRoomsData(){
let reqCount = 0;
const supplierLen = this.hotelBaseInfo.supplier_list.length;

this.hotelBaseInfo.supplier_list.forEach((supplier) => {
this.params.supplier_id = supplier;
hotelProxy.getHotelRooms(this.params)
.then(resp => {
reqCount += 1;

if(resp){


this.roomList.push(...resp.data.room_type_list);
DefaultRoomTypeData.push(...resp.data.room_type_list);    
this.recommendRoomList.push(...resp.data.mismatch_room_type_list);

this.updateMealCountOptions();


if(reqCount === supplierLen){
this.roomList = sortRoomListBySupplierPriority(this.roomList);
this.recommendRoomList = sortRoomListBySupplierPriority(this.recommendRoomList);
}

if(this.roomList.length > 0 || this.recommendRoomList.length > 0 || reqCount === supplierLen){
this.isShowDefaultList = false;
}

if(reqCount === supplierLen){
this.isShowPopFilter = true;
}
}
});
});
},
---------------- 旧逻辑结束 ---------------- */

/**
* 获取房型数据(新版)
* 多供应商同步并发聚合查询: 前端只需请求一次, 由后端并发请求各供应商并统一合并返回.
*/
getRoomsData(){

const params = Object.assign({}, this.params);
delete params.supplier_id;

hotelProxy.getHotelRoomsBySuppliers(params)
.then(resp => {
if(resp){
const data = resp.data || {};
const roomTypeList = data.room_type_list || [];
const mismatchRoomTypeList = data.mismatch_room_type_list || [];



this.roomList.push(...roomTypeList);
DefaultRoomTypeData.push(...roomTypeList);    
this.recommendRoomList.push(...mismatchRoomTypeList);

this.updateMealCountOptions();


this.roomList = sortRoomListBySupplierPriority(this.roomList);
this.recommendRoomList = sortRoomListBySupplierPriority(this.recommendRoomList);

if(this.roomList.length > 0 || this.recommendRoomList.length > 0){
this.isShowDefaultList = false;
}

this.isShowPopFilter = true;
}
});
},

/** 酒店预订 */
onToBooking(resp){
const _this = this;
let params = utils.deepCopy(this.params);

params = Object.assign({}, params, resp);

this.$vux.loading.show({text: this.$i18n.t('hotel.LOADING')});
orderProxy.priceChecker(params)
.then(resp => {
if (resp) {
if (Number(resp.code) === 30509) {
this.$vux.confirm.show({
content: resp.msg,
onCancel () {
},
onConfirm () {
_this.$router.push({name: 'hotel-booking', query: params});
}
});
}else {
this.$router.push({name: 'hotel-booking', query: params});
}
}
this.$vux.loading.hide();
});
},

/** 监听window的scroll事件 */
listenerScroll(){
window.addEventListener('scroll', this.scrollCallback, false);
},

/** 滚动条定位 */
onScroll2Booking(offsetName){
let scrollTop = 0,
headPanelH = 180;   

if(offsetName === 'booking'){
scrollTop = this.$refs.hotelList.offsetTop - 15;   
this.currentScrollName = 'booking';
}else if(offsetName === 'detail'){
scrollTop = this.$refs.introduction.offsetTop - headPanelH;   
this.currentScrollName = 'detail';
}else if(offsetName === 'comment'){
scrollTop = this.$refs.hotelEvaluation.offsetTop - headPanelH;   
this.currentScrollName = 'comment';
}else if(offsetName === 'nearby_hotel'){
scrollTop = this.$refs.nearbyHotel.offsetTop - headPanelH;   
this.currentScrollName = 'nearby_hotel';
}

window.scrollTo(0, scrollTop);
},

/** 滚动事件回调函数 */
scrollCallback(){
const refs = this.$refs;
const coverH = refs.hotelCover.offsetHeight;
const scrTop = document.body.scrollTop || document.documentElement.scrollTop;

const detailT = refs.introduction.offsetTop - 180;
const dateBoxT = refs.dateBox.offsetTop - 45;
const evalT = refs.hotelEvaluation.offsetTop - 180;
const nearbyT = refs.nearbyHotel.offsetTop - 180;

if(parseInt(scrTop) > coverH){
this.isPullDown = true;
}else{
this.isPullDown = false;
}

if(scrTop >= nearbyT){
this.currentScrollName = 'nearby_hotel';
}else if(scrTop >= evalT){
this.currentScrollName = 'comment';
}else if(scrTop >= detailT){
this.currentScrollName = 'detail';
}else if(scrTop >= dateBoxT){
this.currentScrollName = 'booking';
}

if(scrTop > dateBoxT){
this.isShowRoomFilter = true;
}else{
this.isShowRoomFilter = false;
}
},

/** 合并字段 */
mixParams(){
this.params.room_count = this.getRooms;
this.params.adults = this.getAdults;
this.params.children = this.getAges;
},

/** 路由到图片预览页 */
onLinkToImage(){
this.$router.push({name: 'img-preview', params: {hotel_id: this.hotel.id}});
},

/** 酒店地图位置 */
onLinkToMap(){
this.$router.push({
name: 'hotel-map',
query: {
is_unit_hotel: true,
hotel_id: this.params.hotel_id,
hotel_name: this.hotelBaseInfo.hotel_name,
hotel_name_en: this.hotelBaseInfo.hotel_name_en,
address: this.hotelBaseInfo.address,
lat: this.hotelBaseInfo.latitude,
lng: this.hotelBaseInfo.longitude,
date_from: this.params.start_date,
date_to: this.params.end_date,
}});
},

/** 切换日期 */
onGetDate(resp){
const {start, end} = utils.combineDateFromArr(resp.start, resp.end);
const q = {...this.$route.params};


q.start_date = start;
q.end_date = end;
this.$router.replace({name: 'hotel-detail', params: q});

this.params.start_date = start;
this.params.end_date = end;
this.roomList = [];
DefaultRoomTypeData = [];
this.isShowDefaultList = true;

this.getRoomsData();
},

/** 删除筛选条件 */
onDeleteCondition(){
this.recommendRoomList = [];
this.$store.dispatch('setRooms', 1);
this.$store.dispatch('setAdults', 1);
this.$store.dispatch('setChildren', 0);
this.$store.dispatch('setAges', []);
this.mixParams();
this.getHotelDetail();
document.documentElement.scrollTop = 0;
},
},
};



// WEBPACK FOOTER //
// ./src/views/hotel-detail/hotel-detail.vue